import React, { useState, useContext } from "react";
import { observer } from "mobx-react";
import { ContactSelectedCount } from "Components/common/ContactSelectedCount";
import { ContactSearchTableContext } from "./ContactSearchTable";
import PageLimit from "Components/common/PageLimit";
import CustomList from "../CustomList";
import { dataSearchState } from "../state";
import ContactsFound from "./ContactsFound";
import CustomTooltip from "Components/common/CustomTooltip";
import { ActiveFiltersBar } from "../filterComponent/ActiveFiltersBar";
import {
  verifyBulkActionPerformedAndAllow,
  formatDiscoverTotalDisplay
} from "../DataSearchUtils";
import { Utils } from "Utils/utils";
import { MXP_EVENT, PAGE_TYPE } from "Static/MixPanelEvents";

const SearchTableHeader = observer(() => {
  const {
    tableLoading = false,
    contactData = {},
    resetAllDynamicState,
    allContactCheckboxAction,
    setTableLoading
  } = useContext(ContactSearchTableContext);

  const { type = "", limit: selectedLimit = "" } =
    dataSearchState?.rangeSelected || {};

  const getContactsByLimit = (limit = 10) => {
    const performPagePerLimit = () => {
      Utils.mixpanelTrack(MXP_EVENT.PAGE_LIMIT_UPDATED, {
        pageType: PAGE_TYPE.discover,
        pageLimit: limit
      });
      setTableLoading(true);
      dataSearchState.setPageLimit(limit);
      dataSearchState.setCurrentPage(1);
      dataSearchState.setIsFromSeoPage(false);
      dataSearchState.searchPageData();
      resetAllDynamicState();
    };
    if (["bulk", "custom"].includes(dataSearchState?.rangeSelected?.type)) {
      verifyBulkActionPerformedAndAllow(performPagePerLimit, () =>
        dataSearchState.setPageLimit(dataSearchState.pageLimit)
      );
    } else {
      performPagePerLimit();
    }
  };

  const isContactSelected = () => {
    return dataSearchState?.selectedContactData?.length > 0;
  };

  const getTableHeaderStyle = () => {
    if (isContactSelected()) {
      return { justifyContent: "space-between" };
    }
  };

  const hasTableData = () => {
    return (!isContactSelected() && !contactData?.totalContacts > 0) ||
      !dataSearchState.isFilterApplied
      ? "noTableSearchData"
      : "";
  };

  return (
    <section
      className={`searchTableHeader ${hasTableData()}`}
      style={getTableHeaderStyle()}
    >
      <div className="searchTableHeaderLeft">
        {!isContactSelected() ? (
          <ContactsFound />
        ) : (
          <ContactSelectedCount
            selectedCount={
              type
                ? selectedLimit
                : dataSearchState.selectedContactData?.length || 0
            }
            totalCount={contactData.totalContacts}
            totalCountDisplay={formatDiscoverTotalDisplay(contactData.totalContacts)}
            loading={tableLoading}
            allContactSelected={false}
            enableSelectAll={false}
            resetCbk={resetAllDynamicState}
            selectAllCbk={allContactCheckboxAction}
            pageType="discover"
          />
        )}
      </div>
      <div className="searchTableHeaderMiddle">
        <ActiveFiltersBar setTableLoading={setTableLoading} />
      </div>
      {contactData?.totalContacts > 0 ? (
        <div className="actions">
          <PageLimit
            limitPerPage={dataSearchState.pageLimit}
            text=""
            cbk={getContactsByLimit}
            totalCount={contactData?.totalContacts}
            customLimit={[10, 25, 50]} // Discover section limited upto 50 contacts per page
          />
          <CustomList
            hasAddNewList={true}
            hasDelete={false}
            hasEdit={false}
            validateOnHeaderClick={() => true}
            HeaderChildren={<AddToList />}
          />
        </div>
      ) : (
        <div className="searchTableHeaderRightSpacer" aria-hidden="true" />
      )}
    </section>
  );
});

const AddToList = () => {
  const [showTooltip, setTooltip] = useState(false);

  return (
    <div
      className={`addToListBtn ${dataSearchState.selectedContactData?.length > 0 ? "enabled" : ""
        }`}
      onMouseEnter={() => setTooltip(true)}
      onMouseLeave={() => setTooltip(false)}
    >
      <i className="material-icons">playlist_add</i>
      {showTooltip && <CustomTooltip text="Add to List" />}
    </div>
  );
};

export { SearchTableHeader };
export default SearchTableHeader;
